var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.$style.container]},[_c('el-breadcrumb',{class:[_vm.$style.breadcrumb]},_vm._l((_vm.items),function(item,i){return _c('el-breadcrumb-item',{key:i,attrs:{"to":_vm.to(item, i)}},[_vm._v(_vm._s(_vm.normalizeTitle(item.title)))])}),1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }